import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  Typography,
  TableHead,
  TableRow,
  TableContainer,
  Checkbox,
  TablePagination,
  Paper,
  Grid2,
  Autocomplete,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogActions,
  Divider,
} from "@mui/material";
import {
  getAttendance,
  getRevertById,
  updateRevert,
} from "../../services/reports.service";
import { getTokenbyData, getUser } from "../../services/user.service";
import { DatePicker } from "antd";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { ToastError, ToastSuccess } from "../../utils/Toaster/Toaster";
import dayjs from "dayjs";
import CloseIcon from "@mui/icons-material/Close";
import { encrypt, decrypt } from "../../utils/crypto";
import AttendanceReportSummary from "../Attendance/AttendanceReportSummary";
import AttendanceReportDetail from "../Attendance/AttendanceReportDetail";
import MasterCommonTable from "../../sharedComponents/MaterCommonTable/MasterCommonTable";
import Styles from "../Attendance/AttendanceReport.module.scss";

const { RangePicker } = DatePicker;

const Attendance = () => {
  const [data, setData] = useState([]);
  console.log("sataaasjsjjssss", data);
  const [selectedRows, setSelectedRows] = useState([]);
  const [page, setPage] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [isAdmin, setIsAdmin] = useState(null);
  const [userType, setUserType] = useState(null);
  const [selectedEmployeeId, setselectedEmployeeId] = useState(null);
  const [selectedDateRange, setSelectedDateRange] = useState([null, null]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [revertData, setRevertData] = useState([]);
  const [requestedDate, setRequestedDate] = useState([]);
  const [statusCounts, setStatusCounts] = useState({ P: 0, LOP: 0, HD: 0, MP: 0, WO: 0, H: 0, L: 0, CompOff: 0 });

  const [value, setValue] = useState("1");

  // Admin View State
  const [adminView, setAdminView] = useState("SUMMARY"); // SUMMARY | DETAIL
  const [selectedUser, setSelectedUser] = useState(null);
  const [adminFilters, setAdminFilters] = useState(null);

  const handleAdminRowClick = (user, currentFilters) => {
    setSelectedUser(user);
    setAdminFilters(currentFilters);
    setAdminView("DETAIL");
  };

  const handleAdminBack = () => {
    setSelectedUser(null);
    setAdminView("SUMMARY");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getTokenbyData();
        const usersData = res.data;
        console.log("usersData", usersData);
        const isAdmin = usersData?.isOverAllAdmin || false;
        const userId = usersData?.userId;
        setIsAdmin(isAdmin);
        if (isAdmin === true) {
          setUserType("Admin");
        } else {
          setUserType("User");
          setselectedEmployeeId(userId);
        }
        console.log("API call");
      } catch (error) {
        console.error("Error fetching role data:", error);
      }
    };

    fetchData();
  }, []);

  const getAttendanceData = async () => {
    try {
      const formData = {
        userId: selectedEmployeeId,
        date: [dayjs(selectedDateRange[0]), dayjs(selectedDateRange[1])],
      };
      const encryptData = encrypt(formData);

      console.log("encryptData", encryptData);

      const response = await getAttendance({ encryptData });
      const res = decrypt(response.data.result);
      console.log("skakdlaskjalksdasd", res);
      const formatTime = (time) => {
        return dayjs(time).format("hh:mm A");
      };

      const formattedData = res.map((item) => ({
        ...item,
        date: dayjs(item.date).format("DD/MM/YYYY"),
        expectedInTime: formatTime(item.expectedInTime),
        actualInTime:
          item.actualInTime !== null ? formatTime(item.actualInTime) : "-",
        expectedOutTime: formatTime(item.expectedOutTime),
        actualOutTime:
          item.actualOutTime !== null ? formatTime(item.actualOutTime) : "-",
        // actualTaskWorkingTime:
        //   item.actualTaskWorkedHours !== null
        //     ? formatTime(item.actualTaskWorkedHours)
        //     : "-",
      }));

      console.log("sampleeeeieieiee", formattedData);

      setSelectedRows([]);
      setData(formattedData);
      setPage(0);
    } catch (error) {
      console.error("Error fetching attendance data:", error);
    }
  };

  const getUserAttendanceData = async () => {
    try {
      let dateRange;
      if (value === "1") {
        dateRange = [dayjs().startOf("week"), dayjs().endOf("week")]; // this week
      } else if (value === "2") {
        dateRange = [dayjs().startOf("month"), dayjs().endOf("month")]; // this month
      } else {
        dateRange = [dayjs(selectedDateRange[0]), dayjs(selectedDateRange[1])];
      }

      const formData = {
        userId: selectedEmployeeId,
        date: dateRange,
      };
      const encryptData = encrypt(formData);

      const result = await getAttendance({ encryptData });
      const res = decrypt(result.data.result);

      const response = await getRevertById(selectedEmployeeId);
      if (response.data) {
        const modifiedData = response.data?.map((date) =>
          dayjs(date).format("DD/MM/YYYY")
        );

        setRequestedDate(modifiedData);
      }

      const formatTime = (time) => dayjs(time).format("hh:mm A");

      const counts = { P: 0, LOP: 0, HD: 0, MP: 0, WO: 0, H: 0, L: 0, CompOff: 0 };

      const formattedData = res.map((item) => {
        const statusVal = (item.status === "FULL LOP" || item.status === "Full LOP") ? "LOP" : item.status;

        if (statusVal === 'P' || statusVal === 'Present') counts.P++;
        else if (statusVal === 'LOP' || statusVal === 'A') counts.LOP++;
        else if (statusVal === 'HALF LOP' || statusVal === 'Half LOP' || statusVal === 'Half Day') counts.HD++;
        else if (statusVal === 'Miss Punch' || statusVal === 'MP') counts.MP++;
        else if (statusVal === 'WO' || statusVal === 'Weekly Off') counts.WO++;
        else if (statusVal === 'H' || statusVal === 'Holiday') counts.H++;
        else if (statusVal === 'L' || statusVal === 'Leave') counts.L++;
        else if (statusVal === 'CompOff' || statusVal === 'Compoff') counts.CompOff++;

        return {
          ...item,
          date: dayjs(item.date).format("DD/MM/YYYY"),
          expectedInTime: formatTime(item.expectedInTime),
          actualInTime:
            item.actualInTime !== null ? formatTime(item.actualInTime) : "-",
          expectedOutTime: formatTime(item.expectedOutTime),
          actualOutTime:
            item.actualOutTime !== null ? formatTime(item.actualOutTime) : "-",
          // actualTaskWorkingTime:
          //   item.actualTaskWorkedHours !== null
          //     ? formatTime(item.actualTaskWorkedHours)
          //     : "-",
        }
      });

      setSelectedRows([]);
      setData(formattedData);
      setStatusCounts(counts); // Update counts state
      setPage(0);
    } catch (error) {
      console.error("Error fetching attendance data:", error);
    }
  };

  useEffect(() => {
    if (isAdmin === true) {
      if (
        selectedDateRange?.[0] &&
        selectedDateRange?.[1] &&
        selectedEmployeeId
      ) {
        getAttendanceData();
      }
    }
  }, [selectedEmployeeId, selectedDateRange]);

  useEffect(() => {
    if (isAdmin === false) {
      if (value === "3") {
        if (selectedDateRange) {
          if (selectedDateRange[0] && selectedDateRange[1]) {
            getUserAttendanceData();
          }
        }
      } else {
        getUserAttendanceData();
      }
    }
  }, [selectedDateRange, value, selectedEmployeeId]);

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const res = await getUser({ isEnabled: true });
        const configData = res.data.data.map((e) => ({
          ...e,
          label: e?.firstName + (e?.lastName ? " " + e.lastName : ""),
        }));

        // Add the "All" option to the employee data
        setEmployeeData([{ label: "All", _id: "All" }, ...configData]);
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };

    if (userType === "Admin") {
      fetchEmployeeData();
      setPage(0);
    }
  }, [userType]);

  const handleRowSelection = (date) => {
    setSelectedRows((prevSelectedRows) => {
      if (prevSelectedRows?.includes(date)) {
        return prevSelectedRows?.filter((d) => d !== date); // Remove date if already selected
      } else {
        return [...prevSelectedRows, date]; // Add date if not selected
      }
    });
    const LOP = data.filter((row) => selectedRows.includes(row.date));
    const lopData = LOP.map((data) => ({
      date: data.date,
      notes: "",
      type: "",
      ...data,
      ...data,
    }));
    setRevertData(lopData);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleEmployee = (e, v) => {
    if (!selectedDateRange?.length) {
      ToastError("Please select Date");
      return;
    }
    setselectedEmployeeId(v?._id);
  };

  const formatWorkTime = (seconds) => {
    if (seconds < 60) return `${seconds}`;
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return hours > 0
      ? `${hours}:${minutes.toString().padStart(2, "0")} hr`
      : `${minutes} min`;
  };

  const handleRevert = () => {
    const LOP = data.filter((row) => selectedRows.includes(row.date));
    const lopData = LOP.map((data) => ({
      date: data.date,
      notes: "",
      type: "",
      ...data,
    }));
    setRevertData(lopData);
    setOpen(true);
  };

  const handleChange = (index, field, value) => {
    setRevertData((prevData) => {
      const updatedData = [...prevData];
      updatedData[index] = { ...updatedData[index], [field]: value };
      return updatedData;
    });
  };

  const handleSubmit = async () => {
    const modifiedData = revertData.map((e) => ({
      ...e,
      date: dayjs(e.date, "DD-MM-YYYY").toDate(),
      expectedInTime: dayjs(e.expectedInTime, "hh:mm A").toDate(),
      actualInTime: dayjs(e.actualInTime, "hh:mm A").toDate(),
      expectedOutTime: dayjs(e.expectedOutTime, "hh:mm A").toDate(),
      actualOutTime: dayjs(e.actualOutTime, "hh:mm A").toDate(),
      userId: selectedEmployeeId,
    }));

    try {
      const res = await updateRevert(modifiedData);
      if (res?.data?.error === false) {
        ToastSuccess(res?.data?.message);
        getUserAttendanceData();
      }
    } catch (error) {
      console.log("error", error);
    }
    setOpen(false);
  };

  const options = ["Unplanned", "LOP", "Missed Clocking", "Others"];

  const columns = [
    { id: "date", label: "Date" },
    { id: "shift", label: "Shift" },
    { id: "userName", label: "Name" },
    { id: "expectedInTime", label: "Expected In Time" },
    { id: "actualInTime", label: "Actual In Time" },
    { id: "expectedOutTime", label: "Expected Out Time" },
    { id: "actualOutTime", label: "Actual Out Time" },
    { id: "workHours", label: "Time Logger Time" },
    { id: "actualTaskWorkedHours", label: "Tasksheet Time " },
    { id: "status", label: "Status" },
  ];

  const getStyledData = () => {
    return data.map((row) => {
      const isLateIn = dayjs(row.actualInTime, "hh:mm A").isAfter(dayjs(row.expectedInTime, "hh:mm A"));
      const isEarlyOut = dayjs(row.actualOutTime, "hh:mm A").isBefore(dayjs(row.expectedOutTime, "hh:mm A"));

      const expectedDuration = dayjs(row.expectedOutTime, "hh:mm A").diff(dayjs(row.expectedInTime, "hh:mm A"), "seconds");
      const isWorkHoursShort = row.workHours ? row.workHours < expectedDuration : false;
      const isTaskHoursShort = row.actualTaskWorkedHours ? row.actualTaskWorkedHours < expectedDuration : false;

      const statusVal = (row.status === "FULL LOP" || row.status === "Full LOP") ? "LOP" : row.status;
      let statusStyle = {
        fontWeight: '600',
        fontSize: '12px',
        padding: '4px 12px',
        borderRadius: '4px',
        display: 'inline-block',
        minWidth: '30px',
        textAlign: 'center',
        color: '#595959',
        backgroundColor: '#fafafa',
        border: '1px solid #f0f0f0'
      };

      switch (statusVal) {
        case 'P':
        case 'Present':
          statusStyle = { ...statusStyle, color: '#13c2c2', backgroundColor: '#e6fffb', border: '1px solid #87e8de' }; // Cyan
          break;
        case 'WO':
        case 'Weekly Off':
          statusStyle = { ...statusStyle, color: '#00000073', backgroundColor: '#f5f5f5', border: '1px solid #d9d9d9' }; // Grey
          break;
        case 'LOP':
        case 'A':
          statusStyle = { ...statusStyle, color: '#ff4d4f', backgroundColor: '#fff1f0', border: '1px solid #ffa39e' }; // Red
          break;
        case 'L':
        case 'Leave':
          statusStyle = { ...statusStyle, color: '#fa8c16', backgroundColor: '#fff7e6', border: '1px solid #ffd591' }; // Orange
          break;
        case 'H':
        case 'Holiday':
          statusStyle = { ...statusStyle, color: '#722ed1', backgroundColor: '#f9f0ff', border: '1px solid #d3adf7' }; // Purple
          break;
        case 'CompOff':
        case 'Compoff':
          statusStyle = { ...statusStyle, color: '#096dd9', backgroundColor: '#e6f7ff', border: '1px solid #91caff' }; // Blue
          break;
        case 'HALF LOP':
        case 'Half LOP':
          statusStyle = { ...statusStyle, color: '#c41d7f', backgroundColor: '#fff0f6', border: '1px solid #ffadd2' }; // Pink
          break;
      }

      return {
        ...row,
        checkbox: (
          userType === "User" && row.status?.includes("LOP") && row.requested === "Pending" ? (
            <Checkbox
              checked={selectedRows.includes(row.date)}
              onChange={() => handleRowSelection(row.date)}
            />
          ) : ""
        ),
        actualInTime: (
          <span style={{ color: isLateIn ? "red" : "inherit" }}>
            {row.actualInTime}
          </span>
        ),
        actualOutTime: (
          <span style={{ color: isEarlyOut ? "red" : "inherit" }}>
            {row.actualOutTime}
          </span>
        ),
        workHours: (
          <span style={{ color: isWorkHoursShort ? "red" : "inherit" }}>
            {row.workHours > 0 ? formatWorkTime(row.workHours) : "-"}
          </span>
        ),
        actualTaskWorkedHours: (
          <span style={{ color: isTaskHoursShort ? "red" : "inherit" }}>
            {row.actualTaskWorkedHours > 0 ? formatWorkTime(row.actualTaskWorkedHours) : "-"}
          </span>
        ),
        status: (
          <Box sx={statusStyle}>{statusVal}</Box>
        )
      };
    });
  };

  const tableData = getStyledData();

  const tableColumns = [
    ...(userType === "User" ? [{ id: "checkbox", label: "CheckBox" }] : []),
    ...columns.filter(c => c.id !== "status"),
    { id: "status", label: "Status" }
  ];

  return (
    <div className="mainPageRenderingContainer">
      {userType === "Admin" ? (
        <Box className={Styles.Page}>
          {adminView === "SUMMARY" ? (
            <AttendanceReportSummary
              onRowClick={handleAdminRowClick}
              preservedFilters={adminFilters}
            />
          ) : (
            <AttendanceReportDetail
              userId={selectedUser?._id}
              userInfo={selectedUser}
              dateRange={adminFilters?.dateRange}
              onBack={handleAdminBack}
            />
          )}
        </Box>
      ) : userType === "User" ? (
        <Box sx={{ width: "100%", typography: "body1" }}>
          <Box sx={{ width: { xs: "100%", md: "15%" }, float: { md: "right" }, mb: 1, display: { xs: 'flex', md: 'block' }, justifyContent: { xs: 'flex-end', md: 'unset' } }}>
            <Button
              onClick={() => handleRevert()}
              disabled={selectedRows.length <= 0}
              className="Add-Button"
            >
              Reverted
            </Button>
          </Box>
          {/* Summary Chips */}
          <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', mb: 2 }}>
            {[
              { label: 'Present', count: statusCounts.P, color: '#13c2c2', bg: '#e6fffb' }, // Cyan
              { label: 'Absent', count: statusCounts.LOP, color: '#ff4d4f', bg: '#fff1f0' }, // Red (LOP/Absent)
              { label: 'Half Day', count: statusCounts.HD, color: '#ca4886', bg: '#fff0f6' }, // Pink
              { label: 'Weekly Off', count: statusCounts.WO, color: '#595959', bg: '#f5f5f5' }, // Grey
              { label: 'Holiday', count: statusCounts.H, color: '#722ed1', bg: '#f9f0ff' }, // Purple
              { label: 'Comp Off', count: statusCounts.CompOff, color: '#096dd9', bg: '#e6f7ff' }, // Blue
              { label: 'Leave', count: statusCounts.L, color: '#fa8c16', bg: '#fff7e6' }, // Orange
            ].map((chip) => (
              <Box
                key={chip.label}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  border: '1px solid #f0f0f0',
                  borderRadius: '6px',
                  overflow: 'hidden',
                  fontSize: '13px',
                  height: '32px'
                }}
              >
                <Box sx={{ px: 1.5, py: 0.5, backgroundColor: '#fff', color: '#595959', fontWeight: 500 }}>
                  {chip.label}
                </Box>
                <Box sx={{ px: 1.5, py: 0.5, backgroundColor: chip.bg, color: chip.count > 0 ? chip.color : '#bfbfbf', fontWeight: 700, minWidth: '30px', textAlign: 'center', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  {chip.count}
                </Box>
              </Box>
            ))}
          </Box>
          <TabContext value={value}>
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: 2
            }}>
              <TabList
                onChange={(e, v) => {
                  if (v === "3") {
                    setData([]);
                  }
                  setValue(v);
                }}
                aria-label="lab API tabs example"
                variant="scrollable"
                scrollButtons="auto"
                sx={{
                  "& .MuiTabs-indicator": { backgroundColor: "#008080" },
                  "& .MuiTab-root": {
                    color: "black",
                    fontSize: "14px",
                    textTransform: "none",
                  },
                  "& .Mui-selected": { color: "#008080", fontWeight: "bold" },
                }}
              >
                <Tab label="This Week Report" value="1" />
                <Tab label="This Month Report" value="2" />
                <Tab label="Custom Report" value="3" />
              </TabList>

              {value === "3" && (
                <Box sx={{ pr: 2 }}>
                  <RangePicker
                    value={selectedDateRange}
                    onChange={(dates) => setSelectedDateRange(dates)}
                    className="datePicker"
                    style={{ width: 250 }}
                  />
                </Box>
              )}
            </Box>
            <TabPanel value="1">
              <MasterCommonTable
                columns={tableColumns}
                data={tableData}
                isPaginationBar={true}
                tableConfig={{ isAction: false }}
              />
            </TabPanel>
            <TabPanel value="2">
              <MasterCommonTable
                columns={tableColumns}
                data={tableData}
                isPaginationBar={true}
                tableConfig={{ isAction: false }}
              />
            </TabPanel>
            <TabPanel value="3">
              <Box>
                <MasterCommonTable
                  columns={tableColumns}
                  data={tableData}
                  isPaginationBar={true}
                  tableConfig={{ isAction: false }}
                />
              </Box>
            </TabPanel>
          </TabContext>
        </Box>
      ) : null}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle
          sx={{
            fontWeight: 600,
            fontSize: "1.1rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            pb: 1,
          }}
        >
          Enter Notes
          <IconButton onClick={() => setOpen(false)} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <Divider />

        <DialogContent sx={{ mt: 2 }}>
          <Table
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              overflow: "hidden",
            }}
          >
            <TableHead sx={{ backgroundColor: "#f9fafb" }}>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, width: "20%" }}>
                  Date
                </TableCell>
                <TableCell sx={{ fontWeight: 600, width: "50%" }}>
                  Notes
                </TableCell>
                <TableCell sx={{ fontWeight: 600, width: "30%" }}>
                  Type
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {revertData.map((row, index) => (
                <TableRow key={row.date} hover>
                  <TableCell sx={{ verticalAlign: "middle" }}>
                    <Typography variant="body2">{row.date}</Typography>
                  </TableCell>
                  <TableCell sx={{ verticalAlign: "middle" }}>
                    <TextField
                      fullWidth
                      size="small"
                      placeholder="Enter notes..."
                      value={row.notes ?? ""}
                      onChange={(e) =>
                        handleChange(index, "notes", e.target.value)
                      }
                    />
                  </TableCell>
                  <TableCell sx={{ verticalAlign: "middle" }}>
                    <Autocomplete
                      options={options}
                      value={row.type ?? null}
                      onChange={(_, newValue) =>
                        handleChange(index, "type", newValue)
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select type"
                          size="small"
                        />
                      )}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </DialogContent>

        <Divider />

        <DialogActions sx={{ p: 2, justifyContent: "flex-end" }}>
          <Button
            onClick={() => setOpen(false)}
            variant="outlined"
            color="inherit"
            sx={{ textTransform: "none", mr: 1 }}
          >
            Cancel
          </Button>
          <Button onClick={handleSubmit} className="saveButton">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Attendance;
